export enum ROUTES {
  onboardPage = '/v1/onboard',
  homePage = '/',
  loginPage = '/login',
  organisationPage = '/v1/organisations',
  orgProfilePage = '/v1/organisation/profile',
  addOrganisation = '/v1/organisation/add',
  walletPage = '/v1/wallet',
}
